export default __webpack_public_path__ + "static/media/logo-website-website-logo-png-transparent-background-background-15.3c34ab1a.png";